// extracted by mini-css-extract-plugin
export default {"conatiner":"_1cffogf","developerAppsSection":"_gkrhy9"};